import { CFG } from '~/services/cfg'
import { ProjectSnippets } from './ProjectSnippets'

@store()
class SnippetsHub {
  projects = mapValues((proj) => new ProjectSnippets(proj.id), CFG.projects)
}

export const snippetsHub = new SnippetsHub()
